import script from "./base-textarea.vue?vue&type=script&setup=true&lang=ts"
export * from "./base-textarea.vue?vue&type=script&setup=true&lang=ts"

import "./base-textarea.vue?vue&type=style&index=0&id=501480a0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-501480a0"]])

export default __exports__